export const navigationDestinations = [
  {
    name: 'Australia',
    path: '/australia',

    children: [
      {
        name: 'Melbourne',
        path: '/australia/vic/melbourne',
      },
      {
        name: 'Sydney',
        path: '/australia/nsw/sydney',
      },
      {
        name: 'Brisbane',
        path: '/australia/qld/brisbane',
      },
      {
        name: 'Perth',
        path: '/australia/wa/perth',
      },
      {
        name: 'Adelaide',
        path: '/australia/sa/adelaide',
      },
      {
        name: 'Darwin',
        path: '/australia/nt/darwin',
      },
      {
        name: 'Cairns',
        path: '/australia/qld/cairns',
      },
      {
        name: 'Surfers Paradise',
        path: '/australia/qld/surfers-paradise',
      },
    ],
  },
  {
    name: 'By State',
    path: null,

    children: [
      {
        name: 'Queensland',
        path: '/australia/qld',
      },
      {
        name: 'New South Wales',
        path: '/australia/nsw',
      },
      {
        name: 'Victoria',
        path: '/australia/vic',
      },
      {
        name: 'Western Australia',
        path: '/australia/wa',
      },
      {
        name: 'Northern Territory',
        path: '/australia/nt',
      },
      {
        name: 'South Australia',
        path: '/australia/sa',
      },
      {
        name: 'Tasmania',
        path: '/australia/tas',
      },
      {
        name: 'Australian Capital Territory',
        path: '/australia/act',
      },
    ],
  },
];
